import UserNav from "components/profile/UserNav";
import Container from "hardcover-ui/components/Container";
import { UserSerializersUserByline } from "types/serializers";
import Heading from "hardcover-ui/components/Heading";
import Badge from "hardcover-ui/components/Badge";
import Avatar from "hardcover-ui/components/Avatar";
import LocaleNumber from "components/ui/LocaleNumber";
import FollowUserButton from "components/FollowUserButton/FollowUserButton";
import pluralize from "lib/pluralize";

export default function ProfileMiniHeader({
  user,
}: {
  user: UserSerializersUserByline;
}) {
  return (
    <Container size="lg">
      <div className="flex-column sm:flex items-center justify-between mb-3 pt-4 pl-2 lg:pl-4 pr-2">
        <div className="flex items-center gap-2 mb-4 sm:mb-0">
          <Avatar size="lg" image={user.image} alt={user.username} />
          <div className="flex flex-col sm:flex-row items-start sm:items-center sm:gap-2">
            <Heading>{user.name}</Heading>
            <div className="flex items-center gap-2">
              <Badge variant="success" size="sm"><LocaleNumber number={user.booksCount} /> {pluralize("Read", user.booksCount)}</Badge>
              {user.pro ? <Badge variant="primary" size="sm">{user.flair}</Badge> : false}
              {user.isLibrarian ? <Badge variant="primary" size="sm">Librarian</Badge> : false}
            </div>
          </div>
        </div>
        <FollowUserButton user={user} />
      </div>

      <div className="md:mx-2">
        <UserNav user={user} />
      </div>
    </Container>
  );
}
